import React from "react";
import { Input, Panel, SelectPicker } from "rsuite";
import Label from "../../../Components/Label";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../../Atoms/user.atom";
import Responsive from "../../../Components/Responsive";

const B2CInformationsPanel = ({ model, setModel, data, title }) => {
  const user = useRecoilValue(userAtom);

  const handleChange = (key, value) => {
    setModel((prev) => ({
      ...prev,
      infosB2C: {
        ...prev.infosB2C,
        checkoutId: user.checkoutId,
        [key]: value,
      },
    }));
  };

  const handleSelectClient = (clientId) => {
    if (clientId === 0) {
      setModel((prev) => ({
        ...prev,
        infosB2C: null,
      }));
    } else {
      const selectedClient = data.find((client) => client.id === clientId);
      if (selectedClient) {
        setModel((prev) => ({
          ...prev,
          debit: 0,
          credit: 0,
          TotalPrice: 0,
          infosB2C: {
            ...selectedClient,
          },
        }));
      }
    }
  };

  return (
    <div>
      <Label required>{title}</Label>
      <div
        style={{
          background: "#e1e1ff",
          padding: "12px",
        }}
      >
        <Responsive m={6} l={4} xl={6} className="p-5">
          <Label>Recherche:</Label>
          <SelectPicker
            data={[{ label: "Tout", value: 0 }].concat(
              data.map((c) => ({
                label: c.fullName,
                value: c.id,
              }))
            )}
            block
            noSearch
            value={model?.infosB2C?.id || 0}
            onSelect={handleSelectClient}
          />
        </Responsive>
        <Responsive m={12} l={6} xl={6} className="p-5">
          <label>Nom Complet:</label>
          <Input
            value={model.infosB2C?.fullName || ""}
            onChange={(value) => handleChange("fullName", value)}
            disabled={!!model?.infosB2C?.id}
          />
        </Responsive>
        <Responsive m={12} l={6} xl={6} className="p-5">
          <label>CIN ou Numero du passport:</label>
          <Input
            value={model.infosB2C?.passportNumber || ""}
            onChange={(value) => handleChange("passportNumber", value)}
            disabled={!!model?.infosB2C?.id}
          />
        </Responsive>
        <Responsive m={12} l={6} xl={6} className="p-5">
          <label>Téléphone</label>
          <Input
            value={model.infosB2C?.phone || ""}
            onChange={(value) => handleChange("phone", value)}
            disabled={!!model?.infosB2C?.id}
          />
        </Responsive>
      </div>
    </div>
  );
};

export default B2CInformationsPanel;
